import { ClientNode } from '../../../model/client-model/client-node';

/**
 * Returns true if a te has been selected, even if no model has been activated
 */
export function hasSelectedTE(
  node: ClientNode
): node is ClientNode & { nodeProperties: { transitionElement: string } } {
  return !!node.nodeProperties?.transitionElement;
}
